import { getAuth } from "firebase/auth";
import { getAuthCentral } from "../../config/FirebaseConfig";
import { getFirestore, doc, getDoc } from "firebase/firestore";
import { checkDB } from "../../models/DataFunctions.js";
import addLogDocument from "../addLogDocument"; // Assuming you have a similar function to log actions

// Extension to convert ChampStruct to a JSON-compatible format
const champToJson = (champ) => {
  return {
    type: champ.type,
    content: champ.content,
    x: champ.x,
    y: champ.y,
    w: champ.w,
    h: champ.h,
    label: champ.label,
  };
};

const sendDV1 = async (
  champs,
  urlpdf,
  token,
  devisid,
  prefix,
  height,
  width
) => {
  // Ensure the URL uses HTTPS
  const url = prefix + `hexasign/devis/${devisid}/prepare`;

  // Modify the ChampStruct fields based on conditions
  champs = champs.map((champ) => {
    if (champ.type === "Initiales") {
      champ.type = "Signature";
    } else if (champ.type === "Coche") {
      champ.type = "Tampon";
      champ.w = 20;
      champ.h = 20;
      if (champ.content === "true") {
        champ.content =
          "https://firebasestorage.googleapis.com/v0/b/foundry-2dlu01.appspot.com/o/persistent%2Fcochetrue.png?alt=media&token=54b36cc7-13e9-4a07-8edb-dd87705ca982";
      } else {
        champ.content =
          "https://firebasestorage.googleapis.com/v0/b/foundry-2dlu01.appspot.com/o/persistent%2Fcochefalse.png?alt=media&token=74043f9c-b3fe-450f-b813-8c5e48a70af2";
      }
    }
    return champ;
  });

  // Convert the list of ChampStruct objects to a list of JSON-compatible objects
  const fields = champs.map((champ) => champToJson(champ));

  // Define the request body
  const body = {
    pdf: urlpdf,
    fields: fields,
    target_height: height,
    target_width: width,
  };

  // Define headers
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };

  try {
    let start = new Date();
    // Make the POST request
    const response = await fetch(url, {
      method: "POST",
      headers: headers,
      body: JSON.stringify(body), // Encode the body as JSON
    });

    // Check if the user is authenticated
    const auth = getAuthCentral();
    const currentUser = auth.currentUser;
    if (!currentUser) {
      console.error("User not logged in");
      return "";
    }

    // Get Firestore references for the user
    const db = getFirestore();
    const userRef = doc(db, "user", currentUser.uid);
    const userSnapshot = await getDoc(checkDB(userRef));
    const responseText = await response.text();
    let end = new Date();
    let elapsed = end - start;
    if (userSnapshot.exists()) {
      const org_id = userSnapshot.get("org_id");
      await addLogDocument(
        url,
        prefix,
        userRef, // Only log the userRef ID
        org_id,
        response.status.toString(),
        "", // folderid
        "", // docid
        JSON.stringify(body), // request body as string
        responseText,
        "POST",
        elapsed
      );
    }

    // Add log document (avoid passing full document references)

    // Check if the request was successful
    if (response.ok) {
      const jsonResponse = JSON.parse(responseText);
      return jsonResponse["pdf"];
    } else {
      console.error(`Failed to send DV1: ${response.status}`);
      return "";
    }
  } catch (error) {
    // Handle exceptions
    console.error(`Exception occurred: ${error.message}`);
    return "";
  }
};

export default sendDV1;
